<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-19 09:31:17
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2024-03-07 15:36:18
-->
<template>
  <div class="science-research">
    <div class="ui-hearder-bj science-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/pc/kyhz/bj.png')" alt="" srcset="">
      <div class="science-bj-txt container">
        <div class="hearder-bj-title science-bj-title">{{ $t('scienceResearch.title') }}</div>
        <div class="hearder-bj-des science-bj-des">{{ $t('scienceResearch.des') }}</div>
      </div>
    </div>
    <div class="science-content">
      <!-- 人工智能 -->
      <div class="science-intelligence">
        <div class="science-title">{{ $t('scienceResearch.intelligence.title') }}</div>
        <div class="science-des">{{ $t('scienceResearch.intelligence.des') }}</div>
        <div class="flex intelligence-box">
          <div class="flex_1 intelligence-item" v-for="(item, index) in $t('scienceResearch.intelligence.list')" :key="index">
            <div class="intelligence-item-bj transition2">
              <div v-if="language == 'en'" class="intelligence-title-big">{{ item.title }}</div>
              <div class="intelligence-content">
                <div class="intelligence-title">{{ item.title }}</div>
                <div class="intelligence-des">{{ item.des }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 科研合作领域 -->
      <div class="science-field">
        <div class="science-title">{{ $t('scienceResearch.field.title') }}</div>
        <div class="science-des">{{ $t('scienceResearch.field.des') }}</div>
        <div class="flex">
          <div class="flex_1 field-item" v-for="(item, index) in $t('scienceResearch.field.list')" :key="index">
            <img class="wh100" :src="require(`@/assets/images/pc/kyhz/field${index + 1}.png`)" alt="" srcset="">
            <div class="field-content textj">
              <div class="field-title">{{ item.title }}</div>
              <div class="field-des">{{ item.des }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 合作意向 -->
      <div class="science-intention">
        <div class="science-title">{{ $t('scienceResearch.intention.title') }}</div>
        <div class="science-des">{{ $t('scienceResearch.intention.des') }}</div>
        <el-form class="science-intention-form" label-position="left" :inline="true" :model="formData">
          <el-form-item :label="$t('scienceResearch.intention.form.name') + '：'" :label-width="language == 'en' ? '6.8em' : '105px'">
            <el-input v-model="formData.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('scienceResearch.intention.form.company') + '：'" :label-width="language == 'en' ? '9em' : '105px'">
            <el-input v-model="formData.company"></el-input>
          </el-form-item>
          <el-form-item class="wid100" :label="$t('scienceResearch.intention.form.contact') + '：'" :label-width="language == 'en' ? '11em' : '105px'">
            <el-input v-model="formData.contact"></el-input>
          </el-form-item>
          <el-form-item class="wid100" :label="$t('scienceResearch.intention.form.content') + '：'" :label-width="language == 'en' ? '12em' : '105px'">
            <el-input
              type="textarea"
              maxlength="300"
              v-model="formData.content">
            </el-input>
          </el-form-item>
          <div class="wid100 textc p-b-60 p-t-20">
            <el-button plain round disabled>{{ $t('scienceResearch.intention.form.btn') }}</el-button>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      formData: {
        name: '',
        company: '',
        contact: '',
        content: ''
      }
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  created () {
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.pc .science-research {
  .science-bj {
    position: relative;
    img{
      margin-bottom: -3PX;
    }
    .science-bj-txt {
      position: absolute;
      right: 0;
      bottom: 20%;
    }
  }
  .science-content {
    font-size: 18PX;
    line-height: 25PX;
    .science-title {
      color: #000000;
      padding-top: 104PX;
      font-size: 36PX;
      line-height: 50PX;
      text-align: center;
    }
    .science-des {
      color: #333333;
      font-size: 18PX;
      line-height: 24PX;
      padding: 14PX;
      padding-bottom: 105PX;
      text-align: center;
    }
    .intelligence-box {
      background-color: #06102a;
    }
    .intelligence-item {
      position: relative;
      height: 476PX;
      overflow: hidden;
      cursor: pointer;
      .intelligence-item-bj {
        height: 100%;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        transition: all .3s;
        background-color: #06102a;
      }
      &:first-child .intelligence-item-bj{
        background-image: url('~@/assets/images/pc/kyhz/intelligence1.png')
      }
      &:nth-child(2) .intelligence-item-bj{
        background-image: url('~@/assets/images/pc/kyhz/intelligence2.png')
      }
      &:last-child .intelligence-item-bj{
        background-image: url('~@/assets/images/pc/kyhz/intelligence3.png')
      }
      .intelligence-content {
        position: absolute;
        width: 60%;
        left: 20%;
        color: #ffffff;
        top: 365PX;
        transition: all .3s;
        .intelligence-title {
          font-size: 24PX;
          line-height: 33PX;
          text-align: center;
          padding-bottom: 20PX;
        }
        .intelligence-des {
          opacity: 0;
          transition: all 0.3s;
        }
      }
      &:hover {
        .intelligence-item-bj {
          transform: scale(1.1);
        }
        .intelligence-content {
          top: 280PX;
          .intelligence-des {
            opacity: 1;
          }
        }
      }
    }
    .field-item {
      position: relative;
      color: #ffffff;
      // height: 578PX;
      .field-content {
        padding: 20PX 65PX;
        position: absolute;
        width: 100%;
        // top: 298PX;
        bottom: 20%;
        line-height: 25PX;
        .field-title {
          font-size: 24PX;
          line-height: 33PX;
          padding-bottom: 44PX;
        }
      }
    }
  }
  .science-intention {
    padding: 0 20%;
  }
}
.pc.en .science-research {
  .science-bj {
    .science-bj-txt {
      bottom: 10%;
    }
    .science-bj-title {
      font-size: 40PX;
      line-height: 68PX;
    }
  }
  .science-content {
    .science-title {
      font-size: 26PX;
      padding: 84PX 60PX 35PX 60PX;
    }
    .science-des {
      font-size: 14PX;
      padding: 0 20% 105PX 20%;
    }
    .intelligence-box {
      background-color: #06102a;
    }
    .intelligence-item {
      .intelligence-title-big {
        font-size: 20PX;
        line-height: 33PX;
        text-align: center;
        padding-bottom: 20PX;
        position: absolute;
        color: #ffffff;
        width: 100%;
        opacity: 1;
        top: 365PX;
      }
      .intelligence-content {
        width: 80%;
        left: 10%;
        top: auto;
        bottom: -20%;
        font-size: 14PX;
        .intelligence-title {
          opacity: 0;
          font-size: 20PX;
        }
      }
      &:hover {
        .intelligence-item-bj {
          transform: scale(1.1);
        }
        .intelligence-title-big {
          opacity: 0;
        }
        .intelligence-content {
          top: auto;
          bottom: 50PX;
          .intelligence-title {
            opacity: 1;
          }
          .intelligence-des {
            opacity: 0.8;
          }
        }
      }
    }
    .field-item {
      .field-content {
        font-size: 14PX;
        top: 20%;
        bottom: 0;
        .field-title {
          font-size: 20PX;
        }
      }
    }
  }
}
</style>

<style lang="less">
.pc .science-intention {
  .el-form-item {
    width: 50%;
    margin-right: 0;
    position: relative;
    margin-bottom: 55PX;
    &:nth-child(1) {
      width: calc(50% - 61PX);
      margin-right: 61PX;
    }
    &:nth-child(2) {
      width: calc(50% - 61PX);
      margin-left: 61PX;
    }
    .el-form-item__content {
      display: block;
    }
    .el-form-item__label {
      position: absolute;
      z-index: 2;
      color: #333333;
      font-size: 18PX;
      line-height: 25PX;
      padding: 15PX 0;
    }
    .el-input__inner, .el-textarea__inner {
      border: none;
      border-radius: 0;
      border-bottom: 1PX solid rgba(0, 0, 0, 0.3);
      font-size: 18PX;
      &:focus {
        border-bottom-color: #00A0E9;
      }
      &:hover {
        // border-bottom-color:#c0c4cc;
      }
    }
    .el-input__inner {
      height: 55PX;
      line-height: 25PX;
      padding: 15PX 0;
      padding-left: 90PX;
    }
    .el-textarea__inner {
      height: 80PX;
      margin-top: 50PX;
      padding: 5PX 0;
      resize: none;
    }
  }
  .el-button {
    width: 212PX;
    height: 49PX;
    border-radius: 27PX;
    border-color:rgba(0, 0, 0, 0.3);
    color: #333333;
    font-size: 18PX;
    padding: 0 23PX;
    line-height: 48PX;
  }
}
.pc.en .science-intention {
  .el-form-item {
    &:nth-child(2) {
      .el-input__inner {
        padding-left: 6.8em;
      }
    }
    &:nth-child(3) {
      .el-input__inner {
        padding-left: 8.7em;
      }
    }
    .el-form-item__label {
      font-size: 14PX;
    }
    .el-input__inner {
      padding-left: 5em;
    }
  }
  .el-button {
    width: auto;
  }
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 1680PX)  {
  .pc.zh .science-research {
    .science-content {
      font-size: 16PX;
      .science-title {
        font-size: 32PX;
      }
      .intelligence-item {
        height: 413PX;
        .intelligence-content {
          top: 320PX;
          .intelligence-title {
            font-size: 22PX;
          }
        }
        &:hover {
          .intelligence-content {
            top: 210PX;
          }
        }
      }
    }
    .el-button {
      width: 200PX;
      height: 42PX;
      border-radius: 21PX;
      font-size: 16PX;
      padding: 0 18PX;
      line-height: 40PX;
    }
  }
}
@media screen and (max-width: 1600px) {
  .pc.en .science-research {
    .science-content {
      .science-title {
        padding: 64px 60px 35px 60px;
      }
      .science-des {
        padding: 0 10% 80px 10%;
      }
    }
  }
}
@media screen and (max-width: 1680px) and (min-width: 1600px) {
  .pc.en .science-intention {
    .el-button {
      font-size: 16px;
    }
  }
}
</style>
